var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1419_33334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1419_33334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9974 73.3346C35.4418 73.3346 31.1363 72.4596 27.0807 70.7096C23.0252 68.9596 19.4835 66.5707 16.4557 63.543C13.428 60.5152 11.0391 56.9735 9.28906 52.918C7.53906 48.8624 6.66406 44.5569 6.66406 40.0013C6.66406 35.3902 7.53906 31.0707 9.28906 27.043C11.0391 23.0152 13.428 19.4874 16.4557 16.4596C19.4835 13.4319 23.0252 11.043 27.0807 9.29297C31.1363 7.54297 35.4418 6.66797 39.9974 6.66797C40.9418 6.66797 41.7335 6.98741 42.3724 7.6263C43.0113 8.26519 43.3307 9.05686 43.3307 10.0013C43.3307 10.9457 43.0113 11.7374 42.3724 12.3763C41.7335 13.0152 40.9418 13.3346 39.9974 13.3346C32.6085 13.3346 26.3168 15.9319 21.1224 21.1263C15.928 26.3207 13.3307 32.6124 13.3307 40.0013C13.3307 47.3902 15.928 53.6819 21.1224 58.8763C26.3168 64.0707 32.6085 66.668 39.9974 66.668C47.3863 66.668 53.678 64.0707 58.8724 58.8763C64.0668 53.6819 66.6641 47.3902 66.6641 40.0013C66.6641 39.0569 66.9835 38.2652 67.6224 37.6263C68.2613 36.9874 69.053 36.668 69.9974 36.668C70.9418 36.668 71.7335 36.9874 72.3724 37.6263C73.0113 38.2652 73.3307 39.0569 73.3307 40.0013C73.3307 44.5569 72.4557 48.8624 70.7057 52.918C68.9557 56.9735 66.5668 60.5152 63.5391 63.543C60.5113 66.5707 56.9835 68.9596 52.9557 70.7096C48.9279 72.4596 44.6085 73.3346 39.9974 73.3346Z",
    fill: "#AE2573"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressActivity);
export default __webpack_public_path__ + "static/media/progress_activity.0f4a4ce4af6c358fad404c5fd577f960.svg";
export { ForwardRef as ReactComponent };